import request from '@/utils/request'

// 列表
export function listPage(data) {
    return request({
      url: 'admin/portal/fwemployeespost/list',
      method: 'post',
      data
    })
  }
  // 删除
  export function del(data) {
    return request({
      url: 'admin/portal/fwemployeespost/delete',
      method: 'post',
      data
    })
  }
  
  // 新增
  export function save(data) {
    return request({
      url: 'admin/portal/fwemployeespost/save',
      method: 'post',
      data
    })
  }
  
  // 修改
  export function update(data) {
    return request({
      url: 'admin/portal/fwemployeespost/update',
      method: 'post',
      data
    })
  }
  
  // 详情
  export function info(id) {
    return request({
      url: 'admin/portal/fwemployeespost/info/' + id,
      method: 'get'
    })
  }
  // 获取全部列表
  // 列表
export function getAll(data) {
    return request({
      url: 'admin/portal/fwemployeespost/getAll',
      method: 'post',
      data
    })
  }